import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import copy from 'copy-to-clipboard';

import { PAGE_HOME } from '../../config/pages';

import icons from '../../data/icons';

import Link from '../helpers/Link';

class VideoModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            copied: false,
            isOpen: false
        };

        this.copyClick = this.copyClick.bind(this);
        this.shareUrl = this.shareUrl.bind(this);
        this.encodedShareUrl = this.encodedShareUrl.bind(this);

        this.utmContent = 'videopopup';
    }

    componentWillMount() {
        if (typeof this.props.query.video !== 'undefined') {
            this.setState({ isOpen: true });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (typeof nextProps.query.video !== 'undefined') {
            this.setState({ isOpen: true });
        } else {
            this.setState({ isOpen: false });
        }
    }

    shareUrl(utmSource) {
        const { page, subpage, language } = this.props;

        const slashedPage = page ? `/${ page }` : PAGE_HOME;
        const slashedSubpage = subpage ? `/${ subpage }` : '';

        const domain = `https://www.${ process.env.LEMLOCK_DOMAIN }/`;
        const path = `${ process.env.PUBLIC_URL }${ language }${ slashedPage }${ slashedSubpage }`;
        const utm = `?utm_medium=social&utm_campaign=share_from_www&utm_content=${ this.utmContent }&utm_source=${ utmSource }`;

        return `${ domain }${ path }${ utm }&video`;
    }

    encodedShareUrl(utmSource) {
        return encodeURIComponent(this.shareUrl(utmSource));
    }

    copyClick() {
        copy(this.shareUrl('share'));
        this.setState({ copied: true });
        setTimeout(() => this.setState({ copied: false }), 3000);
    }

    render() {
        const { copied, isOpen } = this.state;
        const {
            t, breakpoint, openPage, language, page, subpage
        } = this.props;

        const isAndroid = /Android/i.test(navigator.userAgent);
        const smsSeparator = isAndroid ? '?' : '&';

        return (
            <div className={ cx('modal-container', { open: isOpen }) }>
                <div className="modal">
                    <div className="modal-header">
                        <Link
                          openPage={ openPage }
                          language={ language }
                          page={ page }
                          subpage={ subpage }
                          className="modal-close"
                        >
                            <span className="line line-1"/>
                            <span className="line line-2"/>
                        </Link>
                    </div>
                    <div className="modal-video">
                        {
                            isOpen &&
                                <iframe
                                  title="title"
                                  src={ `https://www.youtube.com/embed/${ t('modals.video.video_id') }?rel=0&amp;controls=1&amp;showinfo=0` }
                                  frameBorder="0"
                                  allow="encrypted-media"
                                  allowFullScreen
                                />
                        }
                    </div>
                    <div className="modal-footer">
                        <div className="modal-share-input">
                            <input type="text" value={ this.shareUrl('share') } readOnly onClick={ this.copyClick }/>
                            <button type="button" onClick={ this.copyClick }>
                                { copied ? t('modals.video.copied') : t('modals.video.copy') }
                            </button>
                        </div>
                        <div className="modal-share-buttons">
                            <a
                              className="share-button facebook"
                              href={ `https://www.facebook.com/sharer/sharer.php?u=${ this.encodedShareUrl('facebook') }` }
                              target="_blank"
                              rel="noopener noreferrer"
                              dangerouslySetInnerHTML={ { __html: icons.social.facebook } }
                            />
                            <a
                              className="share-button twitter"
                              href={ `https://twitter.com/intent/tweet?url=${ this.encodedShareUrl('twitter') }` }
                              target="_blank"
                              rel="noopener noreferrer"
                              dangerouslySetInnerHTML={ { __html: icons.social.twitter } }
                            />
                            <a
                              className="share-button googleplus"
                              href={ `https://plus.google.com/share?url=${ this.encodedShareUrl('google-plus') }` }
                              target="_blank"
                              rel="noopener noreferrer"
                              dangerouslySetInnerHTML={ { __html: icons.social.googleplus } }
                            />
                            <a
                              className="share-button linkedin"
                              href={ `https://www.linkedin.com/shareArticle?mini=true&url=${ this.encodedShareUrl('linkedin') }` }
                              target="_blank"
                              rel="noopener noreferrer"
                              dangerouslySetInnerHTML={ { __html: icons.social.linkedin } }
                            />
                            <a
                              className="share-button xing"
                              href={ `https://www.xing.com/spi/shares/new?url=${ this.encodedShareUrl('xing') }` }
                              target="_blank"
                              rel="noopener noreferrer"
                              dangerouslySetInnerHTML={ { __html: icons.social.xing } }
                            />
                            <a
                              className="share-button email"
                              href={ `mailto: ?body=${ this.encodedShareUrl('mail_client') }&subject=${ t('modals.video.subject') }` }
                              dangerouslySetInnerHTML={ { __html: icons.social.email } }
                            />
                            {
                                breakpoint === 'phone' &&
                                    <a
                                      className="share-button sms"
                                      href={ `sms:${ smsSeparator }body=${ this.encodedShareUrl('sms') }` }
                                      dangerouslySetInnerHTML={ { __html: icons.social.sms } }
                                    />
                            }
                            {
                                breakpoint === 'phone' &&
                                    <a
                                      className="share-button whatsapp"
                                      href={ `https://api.whatsapp.com/send?text=${ this.encodedShareUrl('whatsapp') }` }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      dangerouslySetInnerHTML={ { __html: icons.social.whatsapp } }
                                    />
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

VideoModal.defaultProps = {
    subpage: null,
    query: {}
};

VideoModal.propTypes = {
    t: PropTypes.func.isRequired,
    breakpoint: PropTypes.string.isRequired,
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    page: PropTypes.string.isRequired,
    subpage: PropTypes.string,
    query: PropTypes.objectOf(PropTypes.string)
};

export default VideoModal;



// WEBPACK FOOTER //
// ./src/components/modals/VideoModal.jsx